import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleCard from '../../components/ArticleCard';
import ArticleViewer from '../../components/ArticleViewer';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Account & Settings Category Page
 */
const Account = () => {
  const articles = [
    {
      title: 'Managing Your Profile',
      excerpt: 'Update your profile information and preferences',
      route: getHelpRoute(getHelpArticleRoute('account', 'profile')),
      readTime: 3
    },
    {
      title: 'Privacy Settings',
      excerpt: 'Control your privacy and data sharing preferences',
      route: getHelpRoute(getHelpArticleRoute('account', 'privacy')),
      readTime: 4
    },
    {
      title: 'Notification Preferences',
      excerpt: 'Customize how and when you receive notifications',
      route: getHelpRoute(getHelpArticleRoute('account', 'notifications')),
      readTime: 3
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <ArticleViewer title="Account & Settings" showQA={false}>
              <div className="help-category-intro">
                <p>
                  Manage your account settings, preferences, and personal information.
                </p>
              </div>
              <div className="help-category-articles">
                <h2>Articles</h2>
                <div className="help-articles-grid">
                  {articles.map((article, index) => (
                    <ArticleCard
                      key={index}
                      title={article.title}
                      excerpt={article.excerpt}
                      category="Account & Settings"
                      route={article.route}
                      readTime={article.readTime}
                    />
                  ))}
                </div>
              </div>
            </ArticleViewer>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Account;
